import { useState } from "react";
import { Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";

function Field({ label, children }) {
  return <div><Label className="text-xs font-bold tracking-wide uppercase text-slate-400">{label}</Label><div className="mt-1">{children}</div></div>;
}

export default function OfferEditor({ initial, packages, onSave, onCancel, saving }) {
  const [o, setO] = useState({ active: true, ...initial });
  const isNew = !initial.id;
  const set = (k) => (e) => setO((s) => ({ ...s, [k]: e.target ? e.target.value : e }));

  const submit = () => {
    onSave({
      ...o,
      was_price: o.was_price === "" || o.was_price == null ? null : parseInt(o.was_price, 10),
      now_price: o.now_price === "" || o.now_price == null ? null : parseInt(o.now_price, 10),
      active: !!o.active,
    });
  };

  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm" data-testid="offer-editor">
      <h3 className="font-heading text-lg font-bold text-navy">{isNew ? "New Offer" : `Edit: ${initial.title}`}</h3>
      <div className="mt-5 grid sm:grid-cols-2 gap-4">
        <Field label="Offer Title*"><Input value={o.title || ""} onChange={set("title")} placeholder="Dubai Summer Bonanza" data-testid="oe-title" /></Field>
        <Field label="Linked Package">
          <select value={o.package_slug || ""} onChange={set("package_slug")} className="w-full h-10 rounded-xl border border-slate-200 px-3 text-sm">
            <option value="">— None —</option>
            {packages.map((p) => <option key={p.slug} value={p.slug}>{p.title}</option>)}
          </select>
        </Field>
        <Field label="Tag"><Input value={o.tag || ""} onChange={set("tag")} placeholder="Limited Seats / Bestseller" /></Field>
        <Field label="Departure Note"><Input value={o.departure_note || ""} onChange={set("departure_note")} placeholder="Weekly departures / Departs 21 Nov 2026" /></Field>
        <Field label="Original Price ₹"><Input type="number" value={o.was_price ?? ""} onChange={set("was_price")} placeholder="42500" /></Field>
        <Field label="Offer Price ₹*"><Input type="number" value={o.now_price ?? ""} onChange={set("now_price")} placeholder="37900" /></Field>
        <Field label="Valid Till*"><Input value={o.valid_till || ""} onChange={set("valid_till")} placeholder="31 Aug 2026" /></Field>
        <Field label="Active">
          <label className="flex items-center gap-2 h-10 text-sm text-slate-600">
            <input type="checkbox" checked={!!o.active} onChange={(e) => setO((s) => ({ ...s, active: e.target.checked }))} />
            Show this offer on the homepage
          </label>
        </Field>
      </div>
      <div className="mt-4">
        <Field label="Short Description"><Textarea rows={2} value={o.description || ""} onChange={set("description")} /></Field>
      </div>
      <div className="mt-5 flex gap-3">
        <Button onClick={submit} disabled={saving || !o.title || !o.now_price || !o.valid_till} data-testid="oe-save"
                className="rounded-full bg-navy text-white hover:bg-royal">
          {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : "Save Offer"}
        </Button>
        <Button variant="outline" onClick={onCancel} className="rounded-full">Cancel</Button>
      </div>
    </div>
  );
}
